import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import { BookingContext } from "../pages/BookingContext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { selectedRooms } = useContext(BookingContext);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      const progressBar = document.querySelector(".scroll-progress");
      if (progressBar) progressBar.style.width = `${scrollPercent}%`;
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when mobile menu open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const totalSelected = selectedRooms.length;

  const navItems = [
    { path: "/about", label: "Our Story" },
    { path: "/rooms", label: "Rooms & Suites" },
    { path: "/restaurant", label: "Dining" },
    { path: "/community-center", label: "Community Center" },
  ];

  const navClass = [
    "navbar",
    scrolled ? "scrolled" : "",
    isHome && !scrolled ? "transparent" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <nav className={navClass}>
      <div className="navbar-container">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img
            src="/images/logo-nav.webp"
            srcSet="/images/logo-nav.webp 180w, /images/logo-nav@2x.webp 360w"
            sizes="180px"
            alt="Damtua Inn"
            className="logo-img"
            width={180}
            height={128}
            decoding="async"
          />
          <span className="logo-text">
            <span className="logo-the">The</span>
            <span className="logo-name">Damtua Inn</span>
          </span>
        </Link>

        <ul className="nav-links desktop-nav">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? "active" : ""}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="nav-actions">
          <Link to="/booking" className="reserve-btn desktop-only">
            Reserve
            {totalSelected > 0 && <span className="booking-badge">{totalSelected}</span>}
          </Link>

          <Link to="/booking" className="reserve-btn mobile-only">
            Reserve
            {totalSelected > 0 && <span className="booking-badge">{totalSelected}</span>}
          </Link>

          <button
            className={`menu-icon ${isOpen ? "is-open" : ""}`}
            onClick={toggleMenu}
            aria-label={isOpen ? "Close menu" : "Open menu"}
            aria-expanded={isOpen}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`menu-backdrop ${isOpen ? "open" : ""}`}
        onClick={closeMenu}
        aria-hidden="true"
      ></div>

      <aside className={`mobile-drawer ${isOpen ? "open" : ""}`} aria-hidden={!isOpen}>
        <div className="mobile-drawer-inner">
          <ul className="mobile-nav">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  onClick={closeMenu}
                  className={`mobile-nav-link ${location.pathname === item.path ? "active" : ""}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/booking" onClick={closeMenu} className="mobile-nav-link accent">
                Reserve a Stay
              </Link>
            </li>
          </ul>

          <div className="mobile-drawer-footer">
            <p className="mobile-drawer-label">Contact</p>
            <a href="tel:+8801879917302">+880 1879 917 302</a>
            <a href="mailto:thedamtuainn@gmail.com">thedamtuainn@gmail.com</a>
          </div>
        </div>
      </aside>

      <div className="scroll-progress"></div>
    </nav>
  );
};

export default Navbar;
